import { useEffect, useState} from 'react';

import axios from 'axios';

const useFetchData = ({ vendorid, setLoading } = {}) => {
  const [data, setData] = useState({});
  

  useEffect(() => {
    if (!vendorid || !setLoading) return;
    const fetchData = async () => {
      try {
        setLoading(true);
        const { data: response } = await axios.get(`https://bulkify.in/api/fetch_catogory.php?vid=${vendorid}`);
        setData(response);
      } catch (error) {
        console.error(error)
      }
      finally{
        setLoading(false);
      } 
      
    };

    if (vendorid) {
      fetchData();
    }
  }, [vendorid, setLoading]);

  return {data};
};

export default useFetchData;